import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class LocalizationForm extends ThemeComponent {

    @Ref()
    input!: HTMLInputElement;

    @Ref()
    button!: HTMLButtonElement;

    @Ref()
    panel!: HTMLDivElement;

    @Ref()
    links!: HTMLAnchorElement[];


    init() {
        this.setEventListeners();
    }

    private setEventListeners() {

        this.$listen(this.button, 'click', (event) => {
            event.preventDefault();
            this.openSelector();
        });

        this.$listen(this.button, 'focusout', (event) => {
            event.preventDefault();
            this.closeSelector(event);
        });

        this.$listen(this, 'keyup', (event) => {
            event.preventDefault();
            this.onContainerKeyUp(event);
        });

        for (const link of this.links) {
            this.$listen(link, 'click', (event) => {
                event.preventDefault();
                this.onItemClick(event);
            });
        }
    }

    private openSelector() {
        this.button.focus();
        this.panel.toggleAttribute('hidden');
        this.button.setAttribute('aria-expanded', (this.button.getAttribute('aria-expanded') === 'false').toString());
    }

    private closeSelector(event: FocusEvent) {
        const nodeTarget = event.relatedTarget as Node;
        const shouldClose = nodeTarget && nodeTarget.nodeName === 'BUTTON';
        if (nodeTarget === null || shouldClose) {
            this.hidePanel();
        }
    }

    private onContainerKeyUp(event: KeyboardEvent) {
        if (event.code.toUpperCase() !== 'ESCAPE') {return;}

        this.hidePanel();
        this.button.focus();
    }

    private hidePanel() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', "true");
    }

    private onItemClick(event: Event) {
        event.preventDefault();
        const currentEventTarget = event.currentTarget as HTMLAnchorElement;
        const form = this.querySelector('form');
        if (!form) {return;}
        if (!currentEventTarget) {return;}
        const value = currentEventTarget.dataset.value;

        if (!value) {return;}
        this.input.value = value;

        if (form) {form.submit();}
    }


}
